"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a = require('./rules/ruleset.json'), version = _a.version, userAgents = _a.userAgents, whitelistedUserAgents = _a.whitelistedUserAgents;
var botDetector = null;
function getBotDetector() {
    if (!botDetector) {
        var loweredUserAgents = userAgents.map(function (u) { return u.toLowerCase(); });
        var loweredWhiteList = whitelistedUserAgents.map(function (u) { return u.toLowerCase(); });
        botDetector = new BotDetector(loweredUserAgents, loweredWhiteList);
    }
    return botDetector;
}
exports.getBotDetector = getBotDetector;
var BotDetector = (function () {
    function BotDetector(userAgents, whitelistedUserAgents) {
        this.userAgents = userAgents;
        this.whitelistedUserAgents = whitelistedUserAgents;
    }
    /**
     * Checks if the userAgent is a known bot
     * All whitelisted bots are also classified as bots
     *
     * @param userAgent the client's useragent string
     * @returns true / false if we think the user_agent is a bot or not. null if the userAgent is null/empty
     */
    BotDetector.prototype.isBot = function (userAgent) {
        if (!userAgent || userAgent.length === 0) {
            return null;
        }
        userAgent = userAgent.toLowerCase();
        return this.userAgents.some(function (u) { return userAgent.indexOf(u) !== -1; }) || this.isWhitelistedBot(userAgent);
    };
    BotDetector.prototype.getBots = function (userAgent) {
        if (!userAgent || userAgent.length === 0) {
            return ['emptybot'];
        }
        userAgent = userAgent.toLowerCase();
        return this.userAgents.filter(function (u) { return userAgent.indexOf(u) !== -1; });
    };
    /**
     * Checks if the userAgent is a known whitelisted bot
     * All whitelisted bots are also classified as bots (using isBot)
     *
     * Whitelisted bots will get a coinflip from the AB service, but will not be included in AB metrics.
     *
     * @param userAgent the client's useragent string
     * @returns true / false if we think the user_agent is a whitelisted bot or not. null if the userAgent is null/empty
     */
    BotDetector.prototype.isWhitelistedBot = function (userAgent) {
        if (!userAgent || userAgent.length === 0) {
            return null;
        }
        userAgent = userAgent.toLowerCase();
        return this.whitelistedUserAgents.some(function (u) { return userAgent.indexOf(u) !== -1; });
    };
    BotDetector.prototype.getVersion = function () {
        return version;
    };
    return BotDetector;
}());
exports.BotDetector = BotDetector;
